import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/orders/pharmacies/filters/Index'

import FinishedOrders from '../../containers/orders/pharmacies/widgets/FinishedOrders'
import NotFinishedOrders from '../../containers/orders/pharmacies/widgets/NotFinishedOrders'

import PharmaciesOnline from '../../containers/orders/pharmacies/widgets/PharmaciesOnline'
import PharmaciesOffline from '../../containers/orders/pharmacies/widgets/PharmaciesOffline'
import PharmaciesMaintenance from '../../containers/orders/pharmacies/widgets/PharmaciesMaintenance'
import PharmaciesLead from '../../containers/orders/pharmacies/widgets/PharmaciesLead'

import PharmaciesOrdersFinished from '../../containers/orders/pharmacies/widgets/PharmaciesOrdersFinished'
import PharmaciesOrdersCancelled from '../../containers/orders/pharmacies/widgets/PharmaciesOrdersCancelled'

import NotTotalOrdersFinishedPharmacies from '../../containers/orders/pharmacies/charts/NotTotalOrdersFinishedPharmacies'
import TotalOrdersFinishedPharmacies from '../../containers/orders/pharmacies/charts/TotalOrdersFinishedPharmacies'

// import LowerShipping from '../../containers/orders/pharmacies/charts/LowerShipping'
import GreaterShipping from '../../containers/orders/pharmacies/charts/GreaterShipping'
import PharmaciesTopCancellationGaveUp from '../../containers/orders/pharmacies/charts/PharmaciesTopCancellationGaveUp'
import PharmaciesTopCancellationOutOfStock from '../../containers/orders/pharmacies/charts/PharmaciesTopCancellationOutOfStock'
// import AVGTimePharmacies from '../../containers/orders/pharmacies/charts/AVGTimePharmacies'
import PercentageAntiFraudEnabled from '../../containers/orders/pharmacies/charts/PercentageAntiFraudEnabled'
// import ViewersNumberPharmacies from '../../containers/orders/pharmacies/charts/ViewersNumberPharmacies'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Pharmacies = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <Filters />

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6} xs={12}>
          <FinishedOrders />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
          <NotFinishedOrders />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6} xs={12}>
          <PharmaciesOrdersFinished />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
          <PharmaciesOrdersCancelled />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} xs={12} lg={3} md={6}>
          <PharmaciesOnline />
        </Grid>
        <Grid item sm={12} xs={12} lg={3} md={6}>
          <PharmaciesOffline />
        </Grid>
        <Grid item sm={12} xs={12} lg={3} md={6}>
          <PharmaciesMaintenance />
        </Grid>
        <Grid item sm={12} xs={12} lg={3} md={6}>
          <PharmaciesLead />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6} xs={12}>
            <TotalOrdersFinishedPharmacies />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
            <NotTotalOrdersFinishedPharmacies />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <GreaterShipping />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <PharmaciesTopCancellationGaveUp />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={12} xs={12}>
            <PharmaciesTopCancellationOutOfStock />
        </Grid>
      </Grid>

      {/* <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
            <AVGTimePharmacies />
        </Grid>
      </Grid> */}

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
            <PercentageAntiFraudEnabled />
        </Grid>
        {/* <Grid item lg={6} md={6} xs={12}>
            <ViewersNumberPharmacies />
        </Grid> */}
      </Grid>
    </MainTemplate>
  )
}

export default Pharmacies
